import React from 'react';
import { Logo } from '../../../../components';
import css from './LandingFooter.module.css';

// Landing-page-only footer, matching the mockup's structure. NOT a change
// to the shared FooterContainer (CMS-driven, used on every other page) --
// this component is swapped in as LandingPage's own `footer` prop instead,
// so no other page's footer is touched. Uses the real, shared Logo
// component rather than the mockup's embedded demo image, and real anchor
// links to the sections actually on this page.
const LandingFooter = () => {
  const year = new Date().getFullYear();

  return (
    <footer className={css.footer}>
      <div className={css.wrap}>
        <div className={css.grid}>
          <div className={css.brand}>
            <Logo className={css.logo} layout="desktop" />
            <p className={css.tagline}>Every coach on the map. Every session one tap away.</p>
          </div>

          <div className={css.duality}>
            <div className={css.dualityChip}>
              <b className={css.dualityChipTitle}>Coachify Maps</b>
              <span className={css.dualityChipSub}>Free discovery, open to every coach</span>
            </div>
            <div className={css.dualityChip}>
              <b className={css.dualityChipTitle}>Coachify Marketplace</b>
              <span className={css.dualityChipSub}>Booking, payments, and reviews</span>
            </div>
          </div>

          <div className={css.links}>
            <h4 className={css.linksHeading}>Platform</h4>
            <ul className={css.linksList}>
              <li>
                <a href="#the-map" className={css.link}>
                  The Map
                </a>
              </li>
              <li>
                <a href="#section-featured-coaches" className={css.link}>
                  Find a coach
                </a>
              </li>
              <li>
                <a href="#section-marketplace" className={css.link}>
                  Marketplace
                </a>
              </li>
              <li>
                <a href="#section-become-coach" className={css.link}>
                  For coaches
                </a>
              </li>
            </ul>
          </div>

          <div className={css.links}>
            <h4 className={css.linksHeading}>Legal</h4>
            <ul className={css.linksList}>
              <li>
                <a href="/privacy-policy" className={css.link}>
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="/terms-of-service" className={css.link}>
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="/cancellation-policy" className={css.link}>
                  Cancellation & Refund Policy
                </a>
              </li>
              <li>
                <a href="mailto:support@coachifyusa.com" className={css.link}>
                  Contact support
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className={css.bottom}>
          <span>&copy; {year} Coachify. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
